var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vTableSimple',{staticClass:"margin-15",staticStyle:{"overflow":"hidden","height":"initial"},attrs:{"border":"","stripe":"","data":_vm.data,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }